import { keyMirror } from 'ramda-extension';

export const revisionStates = keyMirror({
	ACCEPTED: null,
	DENIED: null,
	WAITING: null,
});
